import { render } from "./ProfileNotificationsEdit.vue?vue&type=template&id=27195e55&lang=pug"
import script from "./ProfileNotificationsEdit.vue?vue&type=script&lang=js"
export * from "./ProfileNotificationsEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__